import Vue from 'vue'
import 'babel-polyfill'
import ElementUI from 'element-ui'
import '@/assets/css/element-variables.scss'
import App from './App.vue'

import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission'

Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})
